import React from "react";
import { Navigate } from "react-router-dom";
import { usePlan } from "../../contexts/PlanContext";

export const FeatureGate = ({ feature, features, children }) => {
    const { hasFeature, planData, loading } = usePlan();

    if (loading || !planData) return children;

    // Support single feature OR array of features (any match unlocks)
    if (feature) {
        if (!hasFeature(feature)) {
            return <Navigate to="/upgrade" replace />;
        }
    } else if (features) {
        const hasAny = features.some(f => hasFeature(f));
        if (!hasAny) {
            return <Navigate to="/upgrade" replace />;
        }
    }

    return children;
};
